<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "批量开票" : "批量开票" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      max-width='800'
      :fullscreen='$isMobile'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="流水编号"
                  readonly
                  hide-details='auto'
                  outlined
                  :rules="required"
                  v-model="form.serialNumber">
                  <template v-slot:append>
                    <v-btn fab small color="primary" @click='invoiceNumber' class="mt-n2 mr-n2">
                      <v-icon dark>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
               <v-col cols="12" md="6">
               <base-material-date
                  ref='date'
                  :rules="required"
                  hide-details='auto'
                  outlined
                  label='开票时间'
                  v-model='form.writeTimeStr'
                >
                </base-material-date>
              </v-col>
              <!-- <v-col cols="12" md="6">
                <v-text-field label="开票金额" hide-details='auto' outlined :rules="number" v-model="form.money"></v-text-field>
              </v-col> -->
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :items="moneyTypeItems"
                  label="开票内容"
                  v-model="form.moneyTypeId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
               <v-col cols="12" md="6">
                <v-select
                  :items="invoiceTypeItems"
                  label="发票类型"
                  v-model="form.typeId"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
            </v-row>

            <v-card v-if="item.show" class="my-3 pb-3" outlined>
              <v-card-title>
                合计金额：
                <span>{{form.invoices | fmPrice}}</span>
              </v-card-title>
              <v-row v-for="(item, i) in item.data" :key="i" class="px-4">
                <v-col cols="12" md="2">
                  <v-text-field
                    label="开票金额"
                    hide-details='auto'
                    outlined
                    :value="item.surplusInvoiceMoney"
                    :rules="[value => (/^(0|[1-9][0-9]*)$/.test(value) && value <= item.surplusInvoiceMoney ) || `不能超${item.surplusInvoiceMoney}`,]"
                    v-model="form.invoices[i].money">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <div class="py-2">{{item.serialNumber}}</div>
                </v-col>
                <v-col cols="12" md="7">
                  <div class="py-2">{{item.product.name}}</div>
                </v-col>
              </v-row>
            </v-card>

            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="form.addressId"
                  :rules="required"
                  :items="invoiceAddressItems"
                  item-value='id'
                  label="选择开票信息及邮寄地址"
                  outlined
                >
                  <template v-slot:item="{ item }">
                    <v-chip><span>{{item.customerName}}</span></v-chip>
                    <v-chip><span>{{item.taxNumber}}</span></v-chip>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-chip><span>{{item.customerName}}</span></v-chip>
                    <v-chip><span>{{item.taxNumber}}</span></v-chip>
                    <v-chip><span>地址:{{item.address}}</span></v-chip>
                    <v-chip><span>账户:{{item.bankName}}</span></v-chip>
                  </template>
                   <template v-slot:append>
                    <v-btn fab small color="primary" @click='addAddress' class="mt-n2">
                      <v-icon dark>mdi-map-marker-plus-outline</v-icon>
                    </v-btn>
                  </template>
                </v-select>
                <v-alert class="mt-3 mb-0" outlined type="error" elevation="0">
                  开具
                  <span class="text-no-wrap primary white--text">增值税专票</span>时请选择有
                  <span class="text-no-wrap primary white--text">完整开户行</span>和
                  <span class="text-no-wrap primary white--text">完整地址</span>的发票信息！
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea rows='4' label="备注信息" outlined v-model="form.remark"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
    <iaddress-add :item='iAddressModal' @on-load-data='addresses'></iaddress-add>
  </v-container>
</template>

<script>
  import { batchSave } from '@/api/contract/invoice.js'
  import { all } from '@/api/customer/iaddress.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import { serialNumber } from '@/utils/stringUtil.js'
  import IaddressAdd from '@/views/pages/pc/customer/iaddress/components/Add.vue'

  export default {
    name: 'InvoiceBatchAdd',
    components: {
      IaddressAdd
    },
    filters: {
      fmPrice (item) {
        let money = 0
        item.forEach(el => {
          money += Number(el.money)
        })
        return money
      }
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) || `金额必填`,
        ],
        param: {},
        form: {
          addressId: '',
          serialNumber: '',
          writeTime: '',
          writeTimeStr: '',
          typeId: '',
          moneyTypeId: '',
          receiveTypeId: '',
          remark: '',
          invoices: [
            {
              contractId: '',
              money: ''
            }
          ]
        },
        defForm: {
          addressId: '',
          serialNumber: '',
          writeTime: '',
          writeTimeStr: '',
          typeId: '',
          moneyTypeId: '',
          receiveTypeId: '',
          remark: '',
          invoices: [
            {
              contractId: '',
              money: ''
            }
          ]
        },
        moneyTypeItems: [],
        invoiceTypeItems: [],
        receiveTypeItems: [],
        invoiceAddressItems: [],
        iAddressModal: { show: false, data: {} }
      }
    },
    methods: {
      save () {
        this.form.writeTime = new Date(this.form.writeTimeStr).getTime() / 1000
        if (this.$refs.form.validate()) {
          this.loading = true
          batchSave(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      invoiceNumber () {
        this.form.serialNumber = serialNumber('YD.')
      },
      addAddress () {
        this.iAddressModal = { show: true, customerId: this.item.data[0].customer.id, customerName: this.item.data[0].customer.name }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.param.customerId = this.item.data[0].customer.id
            this.form.invoices = []
            const this_ = this
            this.item.data.forEach(el => {
              this_.form.invoices.push(
                {
                  contractId: el.id,
                  money: el.surplusInvoiceMoney
                }
              )
            })
          }
          this.invoiceNumber()
          this.addresses()
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
          this.$refs.form.resetValidation()
        }
      },
      getType () {
        getByPids({
          pids: [
            this.$constants.invoiceTypePid,
            this.$constants.invoiceMoneyTypePid,
            this.$constants.invoiceReceiveTypePid
          ]
        }).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.invoiceTypePid === result.id) {
                this_.invoiceTypeItems = result.data
             } else if (this_.$constants.invoiceMoneyTypePid === result.id) {
                this_.moneyTypeItems = result.data
             } else if (this_.$constants.invoiceReceiveTypePid === result.id) {
                this_.receiveTypeItems = result.data
             }
           })
          }
        })
      },
      addresses () {
        all(this.param).then(res => {
          if (res.status === 200) {
            this.invoiceAddressItems = res.data
          }
        })
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    },
    created () {
      this.getType()
    }
  }
</script>

<style>
</style>
